import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

//utiliser une static query pour récupérer des trucs dans les métadonnées
//remettre les trucs de la social image et la récup via graphql / paramétrer le alt dans gatsby-config
//trouver format card twitter
//trouver types json ld

const query = graphql`
query SEO {
  site {
    siteMetadata {
      title
      siteUrl
      themeColor
      socialImage
      socialImageWidth
      socialImageHeight
      socialAlt
      twitterCreator
      twitterSite
      facebookAppId
    }
  }
}`;

const SEO = ({ infos }) => {
  const { site } = useStaticQuery(query);
  const {
    siteUrl,
    themeColor,
    socialImage,
    socialImageWidth,
    socialImageHeight,
    socialAlt,
    twitterCreator,
    twitterSite,
    facebookAppId
  } = site.siteMetadata;
  const title = (infos.type === "home") ? site.siteMetadata.title : site.siteMetadata.title+" | "+infos.title;
  const description = infos.description;
  return (
    <Helmet
      htmlAttributes={{
        lang: "en-US",
      }}>
      <title>{ title }</title>

      <meta name="robots" content="index, follow, archive" />
      <meta name="description" content={ description } />
      {
        themeColor && <meta name="theme-color" content={ themeColor } />
      }

      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ siteUrl } />
      <meta property="og:site_name" content={ site.siteMetadata.title } />
      <meta property="og:title" content={ title } />
      <meta property="og:description" content={ description } />
      {
        facebookAppId && <meta property="fb:app_id" content={ facebookAppId } />
      }
      {
        socialImage && <meta property="og:image" content={ siteUrl + "/" + socialImage } />
      }
      {
        socialImage && socialImageWidth && <meta property="og:image:width" content={ socialImageWidth } />
      }
      {
        socialImage && socialImageHeight && <meta property="og:image:height" content={ socialImageHeight } />
      }
      {
        socialImage && socialAlt && <meta property="og:image:alt" content={ socialAlt } />
      }
      {
        socialImage && <meta property="twitter:image" content={ siteUrl + "/" + socialImage } />
      }
      {
        socialImage && socialImageWidth && <meta property="twitter:image:width" content={ socialImageWidth } />
      }
      {
        socialImage && socialImageHeight && <meta property="twitter:image:height" content={ socialImageHeight } />
      }
      {
        socialImage && socialAlt && <meta property="twitter:image:alt" content={ socialAlt } />
      }
      <meta name="twitter:title" content={ title } />
      <meta name="twitter:description" content={ description } />
      <meta name="twitter:card" content="summary" />
      {
        twitterCreator && <meta property="twitter:creator" content={ twitterCreator } />
      }
      {
        twitterSite && <meta property="twitter:site" content={ twitterSite } />
      }
    </Helmet>
  );
};
export default SEO;
